<script setup lang="ts">
import { ref, computed } from "vue";
import { storeToRefs } from "pinia";
import { useCounterStore } from "@/stores/counter";
import { useMemberService } from "@/stores/memberFunction/memberService";
import { onMounted } from "vue";

import discount_nav_bg from "@image/memberFunction/03_web/discount_nav_bg.png";
import L_btn_p from "@image/memberFunction/01/L_btn_p.png";
import discount from "@image/memberFunction/03_web/discount.png";

import NewsType1 from "@image/memberFunction/08/news_btn_01.png";
import NewsType2 from "@image/memberFunction/08/news_btn_02.png";
import NewsType3 from "@image/memberFunction/08/news_btn_03.png";
import NewsType4 from "@image/memberFunction/08/news_btn_04.png";

const memberService = useMemberService();
const store = useCounterStore();
const { NewJumpMes } = storeToRefs(memberService);

// 新聞類型
const newsTypes = ref([
  { id: "", title: "全部", isSelect: true },
  { id: "客服", title: "客服", isSelect: false },
  { id: "活動", title: "活動", isSelect: false },
  { id: "維護", title: "維護", isSelect: false },
  { id: "重要", title: "重要", isSelect: false },
]);

// 選擇的新聞類型
const selectedType = ref<string>("");

// 選擇類型
function SelectType(id: string) {
  selectedType.value = id;
  newsTypes.value.forEach((type) => {
    type.isSelect = type.id === id;
  });
}

// 過濾後的新聞列表
const FilteredNewsList = computed(() => {
  if (!selectedType.value) {
    return NewJumpMes.value;
  }
  return NewJumpMes.value.filter((item) => item.sKindTitle0 === selectedType.value);
});

// 選擇新聞詳細
const openNewsDetailAlert = (item: any) => {
  memberService.selectNewsContentAlert(item.nId);
  store.toggleAlertBg();
  store.openNewsContentAlert();
};

function NewsTypeImage(type: string) {
  let image;
  switch (type) {
    case "客服":
      image = NewsType1;
      break;
    case "活動":
      image = NewsType2;
      break;
    case "維護":
      image = NewsType3;
      break;
    case "重要":
      image = NewsType4;
      break;
    default:
      image = NewsType1;
      break;
  }
  return image;
}

onMounted(() => {
  memberService.getNewMessageData();
});
</script>

<template>
  <div class="text-primary">
    <div class="grid grid-cols-12 gap-x-[3vw] gap-y-[1dvh] max-w-[1366px] mx-auto px-[2vw] pb-[10dvh] pt-[5dvh]">
      <div class="relative col-span-3">
        <img v-img-src="discount_nav_bg" alt="" class="w-full" />
        <ul class="absolute top-[10dvh] left-[50%] -translate-x-1/2 w-full">
          <li v-for="type in newsTypes" :key="type.id + type.title + 'NewsListType'">
            <button type="button" class="group relative w-full pl-[3.5vw] py-[2.5dvh]" @click="SelectType(type.id)">
              <div class="h-full w-[calc(100%)] absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2" :class="{
                'hidden group-hover:block': !type.isSelect,
                block: type.isSelect,
              }">
                <img v-img-src="L_btn_p" alt="" class="w-full h-[110%]" />
              </div>
              <div class="relative z-10 w-full h-full flex justify-start items-center">
                <p class="font-bold text-[16px] xl:text-[18px]" :class="{
                  'text-coin group-hover:text-secondary': !type.isSelect,
                  ' text-secondary': type.isSelect,
                }">
                  {{ type.title }}
                </p>
              </div>
            </button>
          </li>
        </ul>
      </div>
      <ul class="col-span-9">
        <li class="mt-5 first:mt-0 relative" v-for="(item, id) in FilteredNewsList" :key="item.nId + id">
          <button @click="openNewsDetailAlert(item)" class="w-full">
            <div class="overflow-hidden relative w-full z-10">
              <div
                class="absolute bottom-[3px] left-1/2 -translate-x-1/2 h-[85%] w-[calc(100%-6px)] xl:rounded-b-[27px] rounded-b-[20px] bg-gradient-to-br from-gray-700 to-gray-900 flex flex-col items-start justify-center px-6">
                <div class="flex items-center gap-[10px] mb-2">
                  <div class="relative">
                    <img v-img-src="NewsTypeImage(item.sKindTitle0)" alt="" class="w-[50px] h-[25px]" />
                    <p
                      class="truncate absolute top-1/2 -translate-y-1/2 w-[90%] left-1/2 -translate-x-1/2 text-black font-bold">
                      {{ item.sKindTitle0 }}
                    </p>
                  </div>
                  <p class="text-[12px] text-gray-300">{{ item.sCreateTime }}</p>
                </div>
                <p class="text-white font-bold text-[18px] text-left">
                  {{ item.sTitle0 }}
                </p>
              </div>
              <img v-img-src="discount" alt="" class="w-full h-full" />
            </div>
          </button>
        </li>
        <li v-if="FilteredNewsList.length === 0" class="mt-5 text-center text-gray-400">
          <p>暫無{{selectedType ? newsTypes.find(t => t.id === selectedType)?.title : ''}}消息</p>
        </li>
      </ul>
    </div>
  </div>
</template>
